import { ConfidentialityConfiguration } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { CONFIDENTIALITY_ACCESS_LEVELS } from '../ConfidentialitySettings.types';
import { getAccessDurationHours } from '../ConfidentialitySettings.utils';

import { ConfidentialityEditModalBean } from './ConfidentialityEditModal.types';

export const formInitializer = (
   confidentialityConfiguration: ConfidentialityConfiguration
) => (): ConfidentialityEditModalBean => ({
   rows: CONFIDENTIALITY_ACCESS_LEVELS.map((accessLevel) => ({
      accessLevel: accessLevel,
      accessDurationHours: getAccessDurationHours(confidentialityConfiguration, accessLevel),
   })),
});
